import { Box } from '@mui/material'
import AiAskBarAgentQuestionSection from './AiAskBarAgentQuestionSection'
import AiAskBarHomeComposerSection from './AiAskBarHomeComposerSection'
import AiAskBarRecentDocuments from './AiAskBarRecentDocuments'
import styles from './index.module.scss'

export default function AiAskBarHomePanel({
  vm,
  actions,
  replyPreview,
  onDismissReplyPreview,
  skipHomeEntrance,
  sendDisabled,
  agentQuestion = null,
  onAgentQuestionConfirm,
  contentWidth,
  buildMode = false,
  hideRecentDocuments = false,
  plainLanding = false,
  onVoiceToggle,
  voiceActive,
  model,
  onModelChange,
  onOpenConnections,
}) {
  // "Landing" here means the DO Catalog composer treatment, which the frames
  // apply to threads as well — same shell, controls and type, only the column
  // width differs. Build mode keeps its own orange-bordered panel.
  const isLanding = !buildMode
  // Recent documents stay a home-screen affordance: in a thread the transcript
  // above is the context, so a row of unrelated files below it is noise.
  const showRecentDocuments = contentWidth !== 'thread' && !buildMode && !hideRecentDocuments
  // Page bodies (Schedules) put the composer in a column of their own content,
  // where a connections caption belongs to the page rather than to this control.
  const pulsePlain = plainLanding || contentWidth === 'page'
  const showContextRow = isLanding && !pulsePlain

  return (
    <Box className={`${styles.homeAskBarLayout}${skipHomeEntrance ? '' : ` ${styles.homeAskBarLayoutEnter}`}`}>
      {agentQuestion ? (
        <AiAskBarAgentQuestionSection question={agentQuestion} onConfirm={onAgentQuestionConfirm} />
      ) : null}
      <AiAskBarHomeComposerSection
        isLanding={isLanding}
        showContextRow={showContextRow}
        showShell={!pulsePlain}
        {...{ vm, actions, replyPreview, onDismissReplyPreview, skipHomeEntrance, buildMode, sendDisabled, onVoiceToggle, voiceActive, model, onModelChange, onOpenConnections, contentWidth, plainLanding }}
      />
      {showRecentDocuments ? (
        <AiAskBarRecentDocuments
          attachments={vm.attachments}
          onAttachDocument={actions.handleAttachRecentDocument}
        />
      ) : null}
    </Box>
  )
}
